/**
 * Normalize game data from backend xhelos structure
 * Backend now sends teamClass, so we only:
 * 1. Parse JSON strings (map layout)
 * NEVER modifies structure beyond JSON parsing
 * 
 * NOTE: mapObjects flattening is handled by useGameStore.flattenMapObjects()
 * to avoid duplication and ensure consistency
 */
export default function normalizeGameData(rawData) {
  // Validation
  if (!rawData) {
    console.warn("[normalizeGameData] No raw data provided");
    return null;
  }
  
  // Start with a shallow copy
  const game = { ...rawData };
  
  // Parse map layout if it's a string (backend sends as JSON string)
  if (typeof game.map?.layout === "string") {
    try {
      game.map.layout = JSON.parse(game.map.layout);
    } catch (e) {
      console.error("[normalizeGameData] Failed to parse map layout:", e);
    }
  }
  
  // Convert resolution_queue from object to array if needed
  // Backend sends {1: action1, 2: action2, ...} but frontend expects array
  if (game.resolution_queue && typeof game.resolution_queue === 'object' && !Array.isArray(game.resolution_queue)) {
    // Convert object to array, preserving order
    // Note: Object.values() preserves numeric key order in modern JS
    const queueArray = [];
    const queueKeys = Object.keys(game.resolution_queue).sort((a, b) => Number(a) - Number(b));
    
    for (const key of queueKeys) {
      // Skip any non-numeric keys or null values
      if (!isNaN(Number(key)) && game.resolution_queue[key] !== null) {
        queueArray.push(game.resolution_queue[key]);
      }
    }
    
    game.resolution_queue = queueArray;
    console.info('[normalizeGameData] Converted resolution_queue from object to array:', queueArray.length, 'actions');
  }
  
  // That's it! No more processing needed:
  // - Backend sends teamClass for all objects
  // - mapObjects flattening is done on-demand in useGameStore
  // - Numbered snapshots (sparse deltas) are processed during merge
  
  return game;
}